import { RouletteEvents } from '../core/events/roulette.js';
import {
  validateRouletteBetConfirmation,
  validateRouletteBetsUpdate,
  validateRouletteGameOver,
} from '../core/validation/roulette.js';

import { BaseSDKService } from './BaseSDKService.js';

/**
 * Roulette SDK service — drop-in replacement for `RouletteAIService` (iframe lib).
 * Method shape + validation match the iframe class exactly. See
 * `BlackjackSDKService` JSDoc for the factory-switch pattern.
 */
export class RouletteSDKService extends BaseSDKService {
  sendWelcome(message?: string): void {
    this.dispatch(RouletteEvents.createWelcome(message));
  }

  sendPlaceBet(minBet?: number, maxBet?: number): void {
    this.dispatch(RouletteEvents.createPlaceBet(minBet, maxBet));
  }

  sendBetsUpdate(bets: RouletteEvents.Bet[], totalBet: number): void {
    validateRouletteBetsUpdate(bets, totalBet);
    this.dispatch(RouletteEvents.createBetsUpdate(bets, totalBet));
  }

  sendBetConfirmation(bets: RouletteEvents.Bet[], totalBet: number, roundId: string): void {
    validateRouletteBetConfirmation(bets, totalBet, roundId);
    this.dispatch(RouletteEvents.createBetConfirmation(bets, totalBet, roundId.trim()));
  }

  sendGameOver(
    spinNumber: number,
    spinColor: RouletteEvents.Color,
    bets: RouletteEvents.BetOutcome[],
    totalBet: number,
    totalWin: number,
    roundId: string,
  ): void {
    validateRouletteGameOver({ spinNumber, spinColor, bets, totalBet, totalWin, roundId });
    this.dispatch(
      RouletteEvents.createGameOver(spinNumber, spinColor, bets, totalBet, totalWin, roundId.trim()),
    );
  }

  sendBetTimerExpired(): void {
    this.dispatch(RouletteEvents.createBetTimerExpired());
  }
}
